import React, { useState } from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import {LoginContext} from './Helper/Context';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Home       from "./pages/home";
import Contact    from "./pages/Contact";
import Layout     from "./pages/layout";
import Farmer     from "./pages/farmer";
import TimeSeries from "./components/timeseries";
import Production from "./components/production";
import Viewer     from "./components/viewer";
import Water     from "./components/water";


import './App.css';
import './components/scrollbar.css';

export const getFullDate = (d) => {
  var date = new Date(d);
  return (date < new Date('2018-01-01')) ? '-' : date.toISOString().split('T')[0];  
};

export default function App() {

const [loggedIn, setLoggedIn] = useState(false);


  return (
    <GoogleOAuthProvider clientId={"1000325475730-cm4enk5lsvpbnipv006sqnm3dhik0kqi.apps.googleusercontent.com"}> 
    <LoginContext.Provider value={{loggedIn, setLoggedIn}}>
      <Routes>
        <Route path="/" element={<Layout />} >

          <Route index element={<Home />} />
          <Route path="/contact" element={<Contact />} />

            {loggedIn ? (
              <>
            <Route path="/farmer/:cropid?" element={<Farmer />} >
                <Route index element={<Viewer />} />
                <Route path="/farmer/:cropid/timeseries" element={<TimeSeries />} />
                <Route path="/farmer/:cropid/production" element={<Production />} />
                <Route path="/farmer/:cropid/water" element={<Water />} />                
            </Route>
              </>
            ) : (
              <Route path='*' element={<Navigate to="/" />} />
            )}
        </Route>
      </Routes>
    </LoginContext.Provider>
    </GoogleOAuthProvider>
  );
}